<template>
  <v-layout align-start>
    <v-flex>
      <!-- Tabs-->
      <div v-if="TablaVisible == 1">
        <template>
          <v-form>
            <v-container grid-list-sm class="pa-4 white">
              <v-row>
                <v-col cols="12" md="12" class="py-0">
                  <v-alert type="success" class="subtitle-2" color="primary">
                    <div class="d-flex align-rigth justify-space-between">
                      <span>Captura de Fletes</span>

                      <div class="d-flex">


                        <v-tooltip v-model="show" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon>
                                assignment_add
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Factura</span>
                        </v-tooltip>


                        <v-tooltip v-model="show" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon>
                                assignment_ind
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Carta Porte</span>
                        </v-tooltip>

                        <v-tooltip v-model="show" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon>
                                assignment_ind
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Carta Porte</span>
                        </v-tooltip>






                      </div>

                    </div>
                  </v-alert>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fletefecha" label="Fecha del Flete" prepend-icon="event" readonly
                        v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker v-model="fletefecha" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-select v-model="vehiculoid" :items="vehiculoselect" label="Vehiculo" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="tadid" :items="tadselect" label="Tad" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="choferid" :items="choferselect" label="Chofer de la Pipa" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletelitros" label="Litros" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="facturaid" label="Factura" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="complementoid" label="Complemento" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="complementofacha" label="Fecha del Pago" prepend-icon="event" readonly
                        v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker v-model="complementofacha" @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-dialog ref="dialog" v-model="modal2" :return-value.sync="time" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="time" label="Picker in dialog" prepend-icon="mdi-clock-time-four-outline"
                        readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-time-picker v-if="modal2" v-model="time" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal2 = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(time)">
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="fletefactorpemex" :items="preciofletetipocostoselect" label="Costo Flete" outlined
                    @change="fletemaspeajesuma()"></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="fletepeaje" :items="preciofletetipocasetaselect" label="Costo Peaje" outlined
                    @change="fletemaspeajesuma()"></v-select>
                </v-col>



                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletemaspeaje" label="Flete y Peaje" outlined type="number"></v-text-field>
                </v-col>
              </v-row>

              <div align="center" justify="center">
                <div class="my-2">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardar" v-if="guardarvisiblesino == 0">Guardar</v-btn>
                </div>
              </div>






            </v-container>



          </v-form>
        </template>
      </div>

      <v-app id="inspire" v-if="TablaVisible == 0">
        <v-card max-width="1200">
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6" class="py-0">
                <v-dialog ref="dialog1" v-model="modal1" :return-value.sync="fecha1" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="fecha1" :readonly="fecha1 == 1" label="Fecha de Inicio" prepend-icon="event"
                      v-bind="attrs" v-on="on" solo @click="listar()"></v-text-field>
                  </template>
                  <v-date-picker v-model="fecha1" scrollable locale="es-es" :readonly="fecha1 == 1">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal1 = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog1.save(fecha1), listar()">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="6" sm="6" md="6" class="py-0">
                <v-dialog ref="dialog" v-model="modal" :return-value.sync="fecha2" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="fecha2" :readonly="fecha2 == 1" label="Fecha Fin" prepend-icon="event"
                      v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker v-model="fecha2" scrollable locale="es-es" :readonly="fecha2 == 1">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(fecha2), listar()">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>

            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-select v-model="clientetadid" :items="clientetadselect" label="Cliente" v-on:change="listar()"
                outlined></v-select>
            </v-col>


            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-text-field v-model="searchTerm" label="Buscar flete" outlined></v-text-field>
            </v-col>



          </v-container>

          <v-toolbar color="primary" dark>
            <v-icon>local_shipping</v-icon>
            <v-spacer></v-spacer>

            <v-toolbar-title>Relacion de Fletes</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="mostrarNuevo()">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn icon @click="reportefleteexcel()">
              <i class="fas fa-file-excel" dark></i>
            </v-btn>
            <v-btn icon @click="reportepdf()">
              <i class="fas fa-file-pdf" dark></i>
            </v-btn>

          </v-toolbar>

          <v-list three-line>
            <template v-for="(item, index) in filteredFletes">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon class="grey lighten-1" dark>
                    account_balance
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title> {{ item.clientenombre }}</v-list-item-title>
                  <v-list-item-subtitle class="text"><span class="text--primary">Fecha:</span>
                    {{ item.fletefecha }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Litros:</span>
                    {{ item.fletelitros }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Combustible:</span>
                    {{ item.combustiblenombre }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Procedente:</span>
                    {{ item.tadnombre }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Factura:</span>
                    {{ item.facturaid }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Carta Porte:</span>
                    {{ item.fletecartaporte }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Importe:</span>
                    {{ item.fletemaspeaje }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-row>
                    <v-menu bottom origin="center center" transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="grey lighten-1" v-bind="attrs" v-on="on">
                          <v-icon>menu</v-icon>
                        </v-btn>
                      </template>

                      <v-list>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="ver(item)">visibility</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="editar(item)">edit</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="eliminar(item)">delete</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon v-if="item.fletepagadosino == 0">
                            <v-icon color="grey lighten-1" @click="pagado(item)">attach_money</v-icon>
                          </v-btn>

                          <v-btn icon v-if="item.fletepagadosino == 1">
                            <v-icon color="grey lighten-1" @click="nopagado(item)">cancel</v-icon>
                          </v-btn>
                        </v-list-item>



                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="whatsappweb(item)">call</v-icon>
                          </v-btn>
                        </v-list-item>



                      </v-list>
                    </v-menu>


                  </v-row>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index < fletesselect.length - 1" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-app>

      <v-dialog v-model="fleteexcel" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Reporte</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="text-center">
                <vue-excel-xlsx :data="fletesselect" :columns="fleteselectexcelcabecera"
                  :file-name="'ReporteFlete:' + new Date().toISOString()" :sheet-name="'sheetname'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn color="success" fab x-large dark>
                        <span style="font-size: 3em">
                          <i class="fas fa-file-excel" dark v-on="on"></i>
                        </span>
                      </v-btn>
                    </template>
                    <span>Reporte en Excel</span>
                  </v-tooltip>
                </vue-excel-xlsx>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";

export default {
  data() {
    return {
      guardarvisible: 0,
      TablaVisible: 0,
      fletefecha: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      complementofacha: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      fecha2: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      modal: false,
      modal1: false,
      menu: false,
      menu1: false,
      modal: false,
      combustibleselect: [],
      clienteid: "",
      clienteselect: [],
      tadid: "",
      tadselect: [],
      facturaid: "",
      combustibleid: "",
      fletelitros: 0,
      fletefactorpemex: 0,
      fletepeaje: 0,
      fletemaspeaje: 0,
      thfletecartaporte: "",
      vehiculoid: "",
      vehiculoselect: [],
      complementoid: 0,
      searchTerm: "",
      preciofletetipocosto: "",
      preciofletetipocaseta: "",
      preciofletetipocostoselect: [],
      preciofletetipocasetaselect: [],

      options: {
        locale: "en-US",
        prefix: "$",
        suffix: "",
        length: 11,
        precision: 2,
      },

      fletesselect: [],
      guardarvisiblesino: 0,
      guardarditasino: 0,
      fleteexcel: 0,
      time: null,
      menu2: false,
      modal2: false,

      fleteselectexcelcabecera: [
        { label: "FECHA", field: "fletefecha" },
        { label: "FACTURA", field: "facturaid" },
        { label: "PRODUCTO", field: "combustiblenombre" },
        { label: "CLIENTE", field: "clientepipanombre" },
        { label: "LITROS", field: "fletelitros" },
        { label: "TAD", field: "tadnombre" },
        { label: "COSTO FLETE FACTOR PEMEX", field: "fletefactorpemex" },
        { label: "PEAJE", field: "fletepeaje" },
        { label: "FLETE Y PEAJE", field: "fletemaspeaje" },
        { label: "CARTA PORTE", field: "fletecartaporte" },
      ],

      choferid: "",
      choferselect: [],

      clientetadid: 0,
      clientetadselect: [],
      url: process.env.VUE_APP_CLOUDINARY_URL_ROOT + "api/fletes/",

    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    filteredFletes() {
      const searchTerm = this.searchTerm.toLowerCase();
      return this.fletesselect.filter(flete => {
        return (
          flete.clientepipanombre.toLowerCase().includes(searchTerm) ||
          flete.fletefecha.toLowerCase().includes(searchTerm) ||
          flete.combustiblenombre.toLowerCase().includes(searchTerm) ||
          flete.tadnombre.toLowerCase().includes(searchTerm) ||
          String(flete.facturaid).toLowerCase().includes(searchTerm) ||
          flete.fletecartaporte.toLowerCase().includes(searchTerm)
        );
      });
    },
  },

  watch: {},

  created() {
    this.selectgasolinatipo();
    this.selectcliente();
    this.selecttad();
    this.listar();
    this.selectvehiculo();
    this.selectchofer();
    this.selectfletepreciocosto();
    this.selectfletepreciocaseta();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    mostrarNuevo() {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 0;
      this.limpiar();
    },

    ocultarNuevo() {
      this.TablaVisible = 0;
      this.limpiar();
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "yellow";
      if (socioestatus == 3) return "#DA0707";
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          listaArray = response.data.combustible;
          listaArray.map(function (x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectfletepreciocosto() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/fleteprecios/listartipo/1", configuracion)
        .then(function (response) {
          listaArray = response.data.fleteprecio;
          listaArray.map(function (x) {
            me.preciofletetipocostoselect.push({
              text: x.fletepreciocosto,
              value: x.fletepreciocosto,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectfletepreciocaseta() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/fleteprecios/listartipo/2", configuracion)
        .then(function (response) {
          listaArray = response.data.fleteprecio;
          listaArray.map(function (x) {
            me.preciofletetipocasetaselect.push({
              text: x.fletepreciocosto,
              value: x.fletepreciocosto,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardar() {
      if (this.fletefecha == "") {
        this.$swal("No se a Especificado la Fecha");
        return;
      }

      if (this.vehiculoid == "") {
        this.$swal("No se a Especificado el Vehiculo");
        return;
      }

      if (this.clienteid == "") {
        this.$swal("No se a Especificado el Cliente");
        return;
      }

      if (this.tadid == "") {
        this.$swal("No se a Especificado el Tad");
        return;
      }

      if (this.combustibleid == "") {
        this.$swal("No se a Especificado el Combustible");
        return;
      }

      if (this.choferid == "") {
        this.$swal("No se a Especificado el Chofer");
        return;
      }

      if (this.fletelitros == "") {
        this.$swal("No se a Especificado los Litros");
        return;
      }

      if (this.facturaid == "") {
        this.$swal("No se a Especificado la Factura");
        return;
      }

      if (this.fletecartaporte == "") {
        this.$swal("No se a Especificado la Carta Porte");
        return;
      }

      if (this.fletefactorpemex == "") {
        this.$swal("No se a Especificado el Costo Flete Factor Pemex");
        return;
      }

      if (this.fletemaspeaje == "") {
        this.$swal(
          "No se a Especificado el Costo Flete Factor Pemex Mas Peaje"
        );
        return;
      }
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      // Guardar
      if (me.guardarditasino == 0) {
        axios
          .post(
            "api/fletes/crear",
            {
              fletefecha: me.fletefecha,
              facturaid: me.facturaid,
              combustibleid: me.combustibleid,
              clienteid: me.clienteid,
              fletelitros: me.fletelitros,
              tadid: me.tadid,
              fletefactorpemex: me.fletefactorpemex,
              fletepeaje: me.fletepeaje,
              fletemaspeaje: me.fletemaspeaje,
              fletecartaporte: me.fletecartaporte,
              vehiculoid: me.vehiculoid,
              choferid: me.choferid,
              complementoid: me.complementoid,
              complementofacha: me.complementofacha,
              complementohora: me.time
            },
            configuracion
          )
          .then(function (response) {
            me.limpiar();
            me.listar();
            me.TablaVisible = 0;
            me.$swal("Flete Capturado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
      // Editar
      if (me.guardarditasino == 1) {
        axios
          .post(
            "api/fletes/actualizar",
            {
              fleteid: me.fleteid,
              fletefecha: me.fletefecha,
              facturaid: me.facturaid,
              combustibleid: me.combustibleid,
              clienteid: me.clienteid,
              fletelitros: me.fletelitros,
              tadid: me.tadid,
              fletefactorpemex: me.fletefactorpemex,
              fletepeaje: me.fletepeaje,
              fletemaspeaje: me.fletemaspeaje,
              fletecartaporte: me.fletecartaporte,
              vehiculoid: me.vehiculoid,
              choferid: me.choferid,
              complementoid: me.complementoid,
              complementofacha: me.complementofacha,
              complementohora: me.time
            },
            configuracion
          )
          .then(function (response) {
            me.TablaVisible = 0;
            me.limpiar();
            me.listar();
            me.$swal("Flete Actualizado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
    },

    fletemaspeajesuma() {
      this.fletemaspeaje = (
        parseFloat(this.fletefactorpemex) + parseFloat(this.fletepeaje)
      ).toFixed(2);
    },

    selectcliente() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientepipas/listar" , configuracion)
        .then(function (response) {
          listaArray = response.data.clientepipa;
          me.clientetadselect.push({
            text: "TODOS",
            value: 0,
          });
          listaArray.map(function (x) {
            me.clienteselect.push({
              text: x.clientepipanombre,
              value: x.clientepipaid,
            });
            me.clientetadselect.push({
              text: x.clientepipanombre,
              value: x.clientepipaid,
            });
          });

        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    whatsappweb(item) {
      //return "https://wa.me/52"6751100973"?text=" + this.whatsappmensaje(item);
      const phoneNumber = item.clientetelefono; // Número de teléfono con código de país
      const message = "Buenos dias, Flete " + item.clientenombre + " El Dia " + item.fletefecha + " Combustible " +
        item.combustiblenombre + " Litros: " + item.fletelitros + " Procedente de " + item.tadnombre + " Factura " + item.facturaid + " Carta Porte No "
        + item.fletecartaporte + " Chofer: " + item.chofernombre + " Pipa: " + item.vehiculoplacas + " Capacidad: " + item.vehiculocapacidad +
        ". Es un Gusto Atenderlo Att: Autotransportes de Combustible Benito S.A. de C.V.";
      const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    },

    selecttad() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/tads/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.tad;
          listaArray.map(function (x) {
            me.tadselect.push({
              text: x.tadnombre,
              value: x.tadid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectvehiculo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/pipas/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.pipa;
          listaArray.map(function (x) {
            me.vehiculoselect.push({
              text: x.pipanombre,
              value: x.pipaid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectchofer() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/choferes/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.chofer;
          listaArray.map(function (x) {
            me.choferselect.push({
              text: x.chofernombre,
              value: x.choferid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    close() {
      this.TablaVisible = 0;
      this.fleteexcel = 0;
    },

    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      if (me.clientetadid == 0) {
        urllistar = "api/fletes/listar/" + me.fecha1 + "/" + me.fecha2 + "/" + "0"
      } else {
        urllistar = "api/fletes/listar/" + me.fecha1 + "/" + me.fecha2 + "/" + me.clientetadid
      }
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.fletesselect = response.data.flete;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    reportefleteexcel() {
      this.fleteexcel = 1;
    },

    reportepdf() {

      window.open(
        this.url +
        "pdffletes/" +
        this.fecha1 +
        "/" +
        this.fecha2 +
        "/" +
        this.clientetadid
      );
    },

    ver(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 1;
      this.guardarditasino = 0;
      this.fletefecha = item.fletefecha;
      this.facturaid = item.facturaid;
      this.combustibleid = item.combustibleid;
      this.clienteid = item.clienteid;
      this.fletelitros = item.fletelitros;
      this.tadid = item.tadid;
      this.fletefactorpemex = item.fletefactorpemex;
      this.fletepeaje = item.fletepeaje;
      this.fletemaspeaje = item.fletemaspeaje;
      this.fletecartaporte = item.fletecartaporte;
      this.vehiculoid = item.vehiculoid;
      this.choferid = item.choferid;
      this.complementoid = item.complementoid
      this.complementofacha = item.complementofacha;
      this.time = item.complementohora
    },

    editar(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 0;
      this.guardarditasino = 1;
      this.fleteid = item.fleteid;
      this.fletefecha = item.fletefecha;
      this.facturaid = item.facturaid;
      this.combustibleid = item.combustibleid;
      this.clienteid = item.clienteid;
      this.fletelitros = item.fletelitros;
      this.tadid = item.tadid;
      this.fletefactorpemex = item.fletefactorpemex;
      this.fletepeaje = item.fletepeaje;
      this.fletemaspeaje = item.fletemaspeaje;
      this.fletecartaporte = item.fletecartaporte;
      this.vehiculoid = item.vehiculoid;
      this.choferid = item.choferid;
      this.complementoid = item.complementoid
      this.complementofacha = item.complementofacha;
      this.time = item.complementohora
    },

    eliminar(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/fletes/eliminar/" + item.fleteid, {}, configuracion)
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });

      
    },

    pagado(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Pagar",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Pagar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/fletes/fletepagadosi/" + item.fleteid, {}, configuracion)
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Pagado", "Se a Pagado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },

    nopagado(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Cancelar el Pago",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cancelar Pago",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/fletes/fletepagadono/" + item.fleteid, {}, configuracion)
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Cancelado", "Se a Cancelado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },

    limpiar() {
      (this.fletefecha = moment(
        this.$store.state.usuario.fecha,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD")),
        (this.facturaid = "");
      this.combustibleid = "";
      this.clienteid = "";
      this.fletelitros = 0;
      this.tadid = "";
      this.fletefactorpemex = 0;
      this.fletepeaje = 0;
      this.fletemaspeaje = 0;
      this.fletecartaporte = "";
      this.vehiculoid = "";
      this.choferid = "";
      this.guardarditasino = 0;
      this.complementoid = 0;
      this.time = null;
      this.menu2 = false;
      this.modal2 = false;
    },
  },
};
</script>
